export default __webpack_public_path__ + "static/media/eastern.65ce1071.jpeg";